import React from 'react';
import NavigationItem from './NavigationItem/NavigationItem.jsx';
import classes from './NavigationItems.css';
import UserMenu from '../../../containers/UserMenu/UserMenu';


const navigationItems = (props) => {


  const navigationItemsClasses = [classes.NavigationItems];

  if (props.openState) {
    navigationItemsClasses.push(classes.ShowDrawerNavigation);
  }

  return <ul className={navigationItemsClasses.join(' ')}>
    <NavigationItem closeDrawer={props.closeDrawer} openState={props.openState} name='Build' link='/build' />
    {props.isAuth ? <NavigationItem closeDrawer={props.closeDrawer} openState={props.openState} name='My Orders' link='/orders' /> : null}
    <UserMenu />
  </ul>
}

export default navigationItems; 


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.jsx